/**
 * QualityToggle - Fast/Quality segmented control for TTS model selection
 *
 * Replaces "Flash/Pro" terminology with more user-friendly "Fast/Quality"
 * Internal values remain 'flash' | 'pro' for backend compatibility
 * Uses consistent typography with the rest of the framework
 */

import * as React from 'react';
import { cn } from '@/lib/utils';

interface QualityToggleProps {
  value: 'flash' | 'pro';
  onChange: (value: 'flash' | 'pro') => void;
  disabled?: boolean;
  className?: string;
}

export const QualityToggle: React.FC<QualityToggleProps> = ({
  value,
  onChange,
  disabled = false,
  className,
}) => {
  return (
    <div className={cn(
      'flex items-center gap-0.5 bg-muted rounded-full p-0.5',
      disabled && 'opacity-50 pointer-events-none',
      className
    )}>
      <button
        type="button"
        onClick={() => onChange('flash')}
        disabled={disabled}
        className={cn(
          'px-2.5 py-1 text-xs font-medium rounded-full transition-all duration-200',
          value === 'flash'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        )}
      >
        Fast
      </button>
      <button
        type="button"
        onClick={() => onChange('pro')}
        disabled={disabled}
        className={cn(
          'px-2.5 py-1 text-xs font-medium rounded-full transition-all duration-200',
          value === 'pro'
            ? 'bg-background text-foreground shadow-sm'
            : 'text-muted-foreground hover:text-foreground'
        )}
      >
        Quality
      </button>
    </div>
  );
};

export default QualityToggle;
